const l = typeof Blob < "u" ? Blob : null;
export {
  l as default
};
